import React from 'react';
import { ArrowRightIcon, FileTextIcon, ZapIcon, MapIcon, ShieldCheckIcon, LockIcon, CreditCardIcon, BookOpenIcon } from 'lucide-react';
export function FinalCTA() {
  const scrollToOffer = () => {
    const element = document.getElementById('oferta');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return;
}